import styled from 'styled-components';
import img3 from '../assets/abstract.jpg';
import showcaseAbout from '../assets/showcaseAbout.jpg';
import showcaseCommercial from '../assets/showcaseCommercial.jpg';
import contactUs from '../assets/contactUs.jpg'
import showcaseTransport from '../assets/showcaseTransport.jpg';
import Residential from '../assets/Residential.jpg';

const ShowCase = styled.div`
  width: 100%;
  height: 500px;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  // background-color: ${({ theme }) => theme.color.darkBlue};
  background-image: url(${showcaseTransport});
  background-position: bottom right;
  color: rgb(255, 255, 255);
  margin-bottom: 50px;
  padding: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;
  }

  .titleBox {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    background-image: url(${img3});
    gap: 20px;
    padding: 60px;
    height: 400px;
    width: 40vw;
    background-color: #fff;
    border-radius: 30px;
    color: #000;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 90vw;
      padding: 20px;
      max-width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 90vw;
      max-width: 100%;
    }
  }

  h1 {
    font-size: 3rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 2rem;
    }
  }
`;
const ShowCaseContact = styled.div`
  width: 100%;
  height: 500px;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  // background-color: ${({ theme }) => theme.color.darkBlue};
  background-image: url(${contactUs});
  background-position: center right;
  color: rgb(255, 255, 255);
  margin-bottom: 50px;
  padding: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;
  }

  .titleBox {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    background-image: url(${img3});
    gap: 20px;
    padding: 60px;
    height: 400px;
    width: 40vw;
    background-color: #fff;
    border-radius: 30px;
    color: #000;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 90vw;
      padding: 20px;
      max-width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 90vw;
      max-width: 100%;
    }
  }

  h1 {
    font-size: 3rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 2rem;
    }
  }
`;
const ShowCaseCommercial = styled.div`
  width: 100%;
  height: 500px;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  // background-color: ${({ theme }) => theme.color.darkBlue};
  background-image: url(${showcaseCommercial});
  color: rgb(255, 255, 255);
  margin-bottom: 50px;
  padding: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;
  }

  .titleBox {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    background-image: url(${img3});
    gap: 20px;
    padding: 60px;
    height: 400px;
    width: 40vw;
    background-color: #fff;
    border-radius: 30px;
    color: #000;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 90vw;
      padding: 20px;
      max-width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 90vw;
      max-width: 100%;
    }
  }

  h1 {
    font-size: 3rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 2rem;
    }
  }
`;
const ShowCaseResidential = styled.div`
  width: 100%;
  height: 500px;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  // background-color: ${({ theme }) => theme.color.darkBlue};
  background-image: url(${Residential});
  color: rgb(255, 255, 255);
  margin-bottom: 50px;
  padding: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;
  }

  .titleBox {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    background-image: url(${img3});
    gap: 20px;
    padding: 60px;
    height: 400px;
    width: 40vw;
    background-color: #fff;
    border-radius: 30px;
    color: #000;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 90vw;
      padding: 20px;
      max-width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 90vw;
      max-width: 100%;
    }
  }

  h1 {
    font-size: 3rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 2rem;
    }
  }
`;
const ShowCaseAbout = styled.div`
  width: 100%;
  height: 500px;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  // background-color: ${({ theme }) => theme.color.darkBlue};
  background-image: url(${showcaseAbout});
  color: rgb(255, 255, 255);
  margin-bottom: 50px;
  padding: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;
  }

  .titleBox {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    background-image: url(${img3});
    gap: 20px;
    padding: 60px;
    height: 400px;
    width: 40vw;
    background-color: #fff;
    border-radius: 30px;
    color: #000;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 90vw;
      padding: 20px;
      max-width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 90vw;
      max-width: 100%;
    }
  }

  h1 {
    font-size: 3rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 2rem;
    }
  }
`;
const ShowCaseSpecial = styled.div`
  width: 100%;
  height: 500px;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  // background-color: ${({ theme }) => theme.color.darkBlue};
  background-image: url(${showcaseAbout});
  color: rgb(255, 255, 255);
  margin-bottom: 50px;
  padding: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;
  }

  .titleBox {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    background-image: url(${img3});
    gap: 20px;
    padding: 60px;
    height: 400px;
    width: 40vw;
    background-color: #fff;
    border-radius: 30px;
    color: #000;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 90vw;
      padding: 20px;
      max-width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 90vw;
      max-width: 100%;
    }
  }

  h1 {
    font-size: 3rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 2rem;
    }
  }
`;
const ShowCaseServices = styled.div`
  width: 100%;
  height: 500px;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  // background-color: ${({ theme }) => theme.color.darkBlue};
  background-image: url(${showcaseCommercial});
  color: rgb(255, 255, 255);
  margin-bottom: 50px;
  padding: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;
  }

  .titleBox {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    background-image: url(${img3});
    gap: 20px;
    padding: 60px;
    height: 400px;
    width: 40vw;
    background-color: #fff;
    border-radius: 30px;
    color: #000;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 90vw;
      padding: 20px;
      max-width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 90vw;
      max-width: 100%;
    }
  }

  h1 {
    font-size: 3rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 2rem;
    }
  }
`;

export { ShowCase, ShowCaseCommercial,ShowCaseAbout, ShowCaseResidential, ShowCaseSpecial, ShowCaseServices, ShowCaseContact };
